import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroItemCard from './HeroItemCard';
import MenuItemCard from './MenuItemCard';

export default function MenuSection({ category, items, lang }) {
  const { t } = useTranslation();

  if (!items || items.length === 0) {
    return null;
  }

  const catLabel = category[`name_${lang}`] || category.name_pl || category.name_tr || '';
  const heroItem  = items.find(i => i.isHero);
  const restItems = items.filter(i => !i.isHero);

  return (
    <section
      id={`section-${category.id}`}
      className="mb-8"
    >
      {/* Section Header */}
      <div className="flex items-center gap-3 px-4 mb-4 pt-2">
        <span className="text-2xl leading-none">{category.icon}</span>
        <h2 className="font-serif font-bold text-bistro-cream tracking-wide"
            style={{ fontSize: 'clamp(1rem, 4.5vw, 1.3rem)' }}>
          {catLabel}
        </h2>
        <div className="flex-1 h-px bg-gradient-to-r from-bistro-border to-transparent" />
      </div>

      <div className="px-4 flex flex-col gap-3">
        {/* Hero card first */}
        {heroItem && (
          <HeroItemCard key={heroItem.id} item={heroItem} lang={lang} />
        )}
        {/* Normal cards */}
        {restItems.map(item => (
          <MenuItemCard key={item.id} item={item} lang={lang} />
        ))}
      </div>
    </section>
  );
}
